import { useState, useEffect } from "react";
import { Check } from "lucide-react";
import { Button } from "@/components/ui/button";
import { ThankYouScreenProps } from "./types";

export const ThankYouScreen = ({
  message,
  brandColor,
  textColor = "#FFFFFF",
  onStartNew,
  onResumeConversation
}: ThankYouScreenProps) => {
  const [showCheck, setShowCheck] = useState(false);

  useEffect(() => {
    // Small delay to trigger the animation after component mount
    const timer = setTimeout(() => {
      setShowCheck(true);
    }, 300);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div
      className="fixed inset-0 flex flex-col items-center justify-center p-6 z-50 text-center"
      style={{ backgroundColor: brandColor }}
    >
      <div className="w-20 h-20 mb-8 relative">
        <div className={`absolute inset-0 rounded-full bg-green-500 flex items-center justify-center transition-all duration-700 ease-out ${showCheck ? 'scale-100 opacity-100' : 'scale-50 opacity-0'
          }`}>
          <Check className="h-12 w-12 text-white" />
        </div>
      </div>

      <h2
        className={`text-2xl md:text-3xl font-bold mb-6 transition-all duration-700 ease-out ${showCheck ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'
          }`}
        style={{ color: textColor }}
      >
        Thank You
      </h2>

      <p
        className={`text-lg md:text-xl max-w-md mb-8 transition-all duration-700 delay-300 ease-out ${showCheck ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'
          }`}
        style={{ color: textColor }}
      >
        {message}
      </p>

      <div className="flex flex-col sm:flex-row gap-3 w-full max-w-md justify-center">
        {onResumeConversation && (
          <Button
            onClick={onResumeConversation}
            className={`transition-all duration-700 delay-500 ease-out ${showCheck ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'
              }`}
            style={{
              backgroundColor: textColor === "#FFFFFF" ? "rgba(255, 255, 255, 0.2)" : "#FFFFFF",
              color: textColor === "#FFFFFF" ? "#FFFFFF" : brandColor,
              border: textColor === "#FFFFFF" ? "1px solid rgba(255, 255, 255, 0.5)" : "none"
            }}
          >
            Resume Conversation
          </Button>
        )}

        <Button
          onClick={onStartNew}
          className={`transition-all duration-700 delay-500 ease-out ${showCheck ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'
            }`}
          style={{
            backgroundColor: textColor === "#FFFFFF" ? "rgba(255, 255, 255, 0.2)" : "#FFFFFF",
            color: textColor === "#FFFFFF" ? "#FFFFFF" : brandColor
          }}
        >
          Start New Conversation
        </Button>
      </div>
    </div>
  );
};
